import Vue from 'vue'
import Router from 'vue-router'
import Peface from 'components/preface/preface'
import About from 'components/about/about'
import Article from 'components/article/article'
import Artist from 'components/artist/artist'
import Works from 'components/works/works'
import Pefaceen from 'components/prefaceen/preface'
import Abouten from 'components/abouten/about'
import Articleen from 'components/articleen/article'
import Artisten from 'components/artisten/artist'
import Worksen from 'components/worksen/works'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/preface'
    },
    {
      path: '/preface',
      component: Peface,
    },
    {
      path: '/about',
      component: About,
    },
    {
      path: '/article',
      component: Article,
    },
    {
      path: '/artist',
      component: Artist,
    },
    {
      path: '/works',
      component: Works,
    },
    {
      path: '/prefaceen',
      component: Pefaceen,
    },
    {
      path: '/abouten',
      component: Abouten,
    },
    {
      path: '/articleen',
      component: Articleen,
    },
    {
      path: '/artisten',
      component: Artisten,
    },
    {
      path: '/worksen',
      component: Worksen,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js